import React, { useState } from "react";
import { BootstrapModal } from "../BootstrapModal/Modal";
import { CgClose } from "react-icons/cg";
import Button from "../Button/Button";
import Typogaphy from "../Typography/Typography";
import { useGetUpdateGroupingItemStatus } from "../../hooks/useCrm";

export const UpdateGroupingItemStatusModal = ({ show, handleClose, id }) => {
  const [button] = useState(false);

  const { mutateAsync: update } = useGetUpdateGroupingItemStatus();
  const handleUpdate = async () => {
    await update({ IdGropingNewUserCrm: id });
  };
  return (
    <BootstrapModal
      modaltitle="تغییر وضعیت دسته بندی"
      handleClose={handleClose}
      show={show}
      moreButton={button}
      size="md"
      closebutton={
        <Button style={{ width: "40px", border: "none" }} onclick={handleClose}>
          <CgClose />
        </Button>
      }
    >
      <div className="row">
        <div className="col-12">
          <Typogaphy size="15px">
            آیا از تغییر وضعیت این دسته بندی مطمئن هستید؟
          </Typogaphy>
        </div>
        <div className="col-6 mt-2">
          <Button
            bgColor="#009ef7"
            color="#fff"
            onclick={() => {
              handleUpdate();
              handleClose();
            }}
          >
            بله
          </Button>
        </div>
        <div className="col-6 mt-2">
          <Button bgColor="#f1416c" color="#fff" onclick={handleClose}>
            خیر
          </Button>
        </div>
      </div>
    </BootstrapModal>
  );
};
